var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78166 5.33312L5.20566 1.75712L6.14833 0.814453L11.3337 5.99979L6.14833 11.1851L5.20566 10.2425L8.78166 6.66645H0.666992V5.33312H8.78166Z",
    fill: "#CD9700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowYellow);
export default __webpack_public_path__ + "static/media/arrowYellow.a6558c4b25bf7a03c6e1b85f5f94e5de.svg";
export { ForwardRef as ReactComponent };